const BugHole = {
    elemName: '虫損',
    type: 'inline',
    doc: '虫損により判読できない箇所を示します。□の数で判読できない文字の数を表します。',
    example: '虫損した□文字',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '{{$text}}',
    htmlTemplate: `<span {{{$htmlId}}} class="BugHole {{$classes}}">{{{$1}}}</span>`,
    xmlTemplate: `<gap {{{$xmlId}}} {{{$xmlSubtypes}}}" quantity="{{$text.length}}" unit="chars" reason="wormhole"/>`,
    docxTemplate: `<w:r><w:t>{{{$$1}}}</w:t></w:r>`,
    latexTemplate: '{{$text}}'
};
export default BugHole;
// import { ConversionRule } from '../ConversionRule';
// import { KojiASTNode } from '../../KojiAstBuilder';
// export default class BugHole extends ConversionRule {
// 	get elemName() {
// 		return '虫損';
// 	}
// 	toXML(node: KojiASTNode): string {
// 		const text = this.converter.convertChildren(node.children);
// 		return `<gap quantity="${text.length}" unit="chars" reason="wormhole"/>`;
// 	}
// 	toText(node: KojiASTNode): string {
// 		const text = this.converter.convertChildren(node.children);
// 		return `${text}`;
// 	}
// 	toHTML(node: KojiASTNode) {
// 		const text = this.convertChildren(node.children);
// 		return `<span class="BugHole inline" >${text}</span>`;
// 	}
// }
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnVnSG9sZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb252ZXJ0ZXIvaW5saW5lX3J1bGVzL0J1Z0hvbGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxPQUFPLEdBQW1CO0lBQy9CLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLFFBQVE7SUFDZCxHQUFHLEVBQUUseUNBQXlDO0lBQzlDLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLGVBQWUsRUFBRSxDQUFDO0lBQ2xCLGVBQWUsRUFBRSxDQUFDO0lBQ2xCLFlBQVksRUFBRSxXQUFXO0lBQ3pCLFlBQVksRUFBRSxrRUFBa0U7SUFDaEYsV0FBVyxFQUFFLG9HQUFvRztJQUNqSCxZQUFZLEVBQUUsaUNBQWlDO0lBQy9DLGFBQWEsRUFBRSxXQUFXO0NBQzFCLENBQUM7QUFFRixlQUFlLE9BQU8sQ0FBQztBQUV2QixzREFBc0Q7QUFDdEQsc0RBQXNEO0FBRXRELHdEQUF3RDtBQUN4RCxvQkFBb0I7QUFDcEIsaUJBQWlCO0FBQ2pCLEtBQUs7QUFFTCxzQ0FBc0M7QUFDdEMsZ0VBQWdFO0FBQ2hFLDhFQUE4RTtBQUM5RSxLQUFLO0FBRUwsdUNBQXVDO0FBQ3ZDLGdFQUFnRTtBQUNoRSxzQkFBc0I7QUFDdEIsS0FBSztBQUVMLCtCQUErQjtBQUMvQixzREFBc0Q7QUFDdEQsMkRBQTJEO0FBQzNELEtBQUs7QUFDTCxJQUFJIn0=